 
 
 
 
 
 
define([
    'leaflet',
    './iconContent'
], function(
    L,
    iconContent
) {
    'use strict';
    var classes = {
        container: 'tomtom-point-content__name-container',
        name: 'tomtom-point-content__name'
    };

    return function(poiData) {
        var div,
            span;

        div = L.DomUtil.create('div', classes.container);
        div.appendChild(iconContent(poiData));

        span = L.DomUtil.create('span', classes.name, div);
        span.innerHTML = poiData.name;

        return div;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/details/nameContent.js